import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

/** Initialise Sentry once at app bootstrap.
 *  No-op when DSN missing or NODE_ENV !== 'production'. */
export const initSentry = () => {
  if (!DSN || process.env.NODE_ENV !== 'production') return;
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.1,
    tracePropagationTargets: [process.env.REACT_APP_BACKEND_URL].filter(Boolean),
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Script error.',
      'Non-Error promise rejection captured',
    ],
  });
};

export { Sentry };
